export const UPDATED = "4 Νοεμβρίου 2026";

const CONTACT = "Koraniconstructiongroup@gmail.com";

export const POLICY = [
  {
    title: "Υπεύθυνος επεξεργασίας",
    list: [
      "Επωνυμία: KORANI CONSTRUCTION GROUP ΜΟΝΟΠΡΟΣΩΠΗ ΙΚΕ",
      "ΑΦΜ: 803446029",
      "Διεύθυνση: Ελευθερίου Βενιζέλου 12, Κιλκίς",
      "Τηλέφωνο: +30 698 765 4456",
      `Email: ${CONTACT}`,
    ],
  },
  {
    title: "Ποια δεδομένα συλλέγουμε",
    body: ["Όταν συμπληρώνετε τη φόρμα «Ζητήστε προσφορά» συλλέγουμε μόνο όσα μας δίνετε:"],
    list: [
      "Ονοματεπώνυμο",
      "Τηλέφωνο",
      "Email (προαιρετικό)",
      "Υπηρεσία που σας ενδιαφέρει (π.χ. ανακαίνιση, κατασκευή, ηλεκτρολογικά, υδραυλικά, βαφές)",
      "Περιοχή / πόλη ή διεύθυνση του έργου",
      "Περιγραφή της εργασίας",
      "Τη γλώσσα της σελίδας και την ημερομηνία υποβολής",
      "Τη διεύθυνση IP της σύνδεσής σας, μόνο για προστασία από μαζικές/κακόβουλες υποβολές",
    ],
  },
  {
    title: "Δεδομένα που αποθηκεύονται στη συσκευή σας",
    list: [
      "Την επιλογή γλώσσας (Ελληνικά/Αγγλικά), στον τοπικό χώρο αποθήκευσης του προγράμματος περιήγησης.",
      "Μια σελίδα «εκτός σύνδεσης» και το εικονίδιο της εφαρμογής, ώστε η εφαρμογή να εμφανίζει μήνυμα όταν δεν υπάρχει internet. Δεν αποθηκεύονται στη συσκευή στοιχεία της φόρμας.",
    ],
    after: ["Δεν χρησιμοποιούμε διαφημιστικά cookies και δεν δημιουργούμε λογαριασμούς πελατών."],
  },
  {
    title: "Για ποιο σκοπό και με ποια νομική βάση",
    list: [
      "Για να επικοινωνήσουμε μαζί σας, να κανονίσουμε αυτοψία και να σας στείλουμε προσφορά για το έργο σας — βάση: λήψη μέτρων πριν από τη σύναψη σύμβασης κατόπιν αιτήματός σας (άρθρο 6 παρ. 1 στοιχ. β΄ GDPR).",
      "Για την ασφάλεια της ιστοσελίδας και την αποτροπή κατάχρησης της φόρμας (διεύθυνση IP) — βάση: έννομο συμφέρον (άρθρο 6 παρ. 1 στοιχ. στ΄ GDPR).",
      "Για στατιστικά λειτουργίας της ιστοσελίδας από την πλατφόρμα φιλοξενίας (βλ. ενότητα 5) — βάση: έννομο συμφέρον για τη σωστή λειτουργία και βελτίωση της υπηρεσίας.",
    ],
    after: ["Δεν χρησιμοποιούμε τα δεδομένα σας για διαφήμιση, δεν τα πωλούμε και δεν λαμβάνουμε αυτοματοποιημένες αποφάσεις για εσάς."],
  },
  {
    title: "Πού αποθηκεύονται και ποιοι πάροχοι τα επεξεργάζονται",
    list: [
      "Emergent (Emergent Labs): φιλοξενία της ιστοσελίδας/εφαρμογής και της βάσης δεδομένων όπου αποθηκεύονται τα αιτήματα, καθώς και η υπηρεσία αποστολής email που μας ειδοποιεί για κάθε νέο αίτημα.",
      "Google (Gmail): το email ειδοποίησης με τα στοιχεία του αιτήματος παραδίδεται στο εταιρικό μας γραμματοκιβώτιο Gmail.",
      "PostHog, μέσω της πλατφόρμας Emergent: στατιστικά χρήσης της ιστοσελίδας (π.χ. σελίδες που προβλήθηκαν, τύπος συσκευής) και καταγραφή περιήγησης για τον εντοπισμό τεχνικών προβλημάτων.",
      "Google Fonts, Unsplash και Pexels: φόρτωση γραμματοσειρών και εικόνων της ιστοσελίδας. Για τη φόρτωσή τους ο πάροχος λαμβάνει τη διεύθυνση IP σας.",
    ],
    after: [
      "Οι πάροχοι αυτοί επεξεργάζονται τα δεδομένα για λογαριασμό μας ή για να παρέχουν την υπηρεσία τους. Ορισμένοι μπορεί να επεξεργάζονται δεδομένα εκτός του Ευρωπαϊκού Οικονομικού Χώρου (π.χ. στις ΗΠΑ), με τις εγγυήσεις που προβλέπει ο GDPR σύμφωνα με τους όρους τους (π.χ. Τυποποιημένες Συμβατικές Ρήτρες).",
      "Τα στοιχεία των αιτημάτων δεν κοινοποιούνται σε συνεργάτες, υπεργολάβους ή τρίτους. Πρόσβαση έχει μόνο η διοίκηση της εταιρείας.",
    ],
  },
  {
    title: "Πόσο καιρό τα κρατάμε",
    list: [
      "Αιτήματα προσφοράς: έως 2 χρόνια μετά το τελευταίο σας αίτημα και στη συνέχεια διαγράφονται αυτόματα — εκτός αν έχει συναφθεί σύμβαση, οπότε ισχύουν οι νόμιμες υποχρεώσεις διατήρησης (π.χ. φορολογικές).",
      "Διεύθυνση IP για προστασία της φόρμας: διαγράφεται αυτόματα μέσα σε 24 ώρες.",
      "Μπορείτε να ζητήσετε διαγραφή νωρίτερα οποιαδήποτε στιγμή (ενότητα 8).",
    ],
  },
  {
    title: "Πώς προστατεύουμε τα δεδομένα",
    list: [
      "Όλη η επικοινωνία με την ιστοσελίδα και την εφαρμογή γίνεται με κρυπτογραφημένη σύνδεση HTTPS.",
      "Η πρόσβαση στα αιτήματα γίνεται μόνο από ιδιωτικό πίνακα διαχείρισης με προσωπικό κωδικό, ο οποίος αποθηκεύεται κρυπτογραφημένος.",
      "Συνεργάτες της εταιρείας δεν έχουν πρόσβαση στα στοιχεία των πελατών.",
    ],
  },
  {
    title: "Τα δικαιώματά σας",
    body: ["Έχετε δικαίωμα πρόσβασης, διόρθωσης, διαγραφής, περιορισμού της επεξεργασίας, φορητότητας και εναντίωσης στην επεξεργασία των δεδομένων σας."],
    list: [
      `Για να ζητήσετε αντίγραφο ή διαγραφή των στοιχείων σας, στείλτε email στο ${CONTACT} ή καλέστε στο +30 698 765 4456, αναφέροντας το ονοματεπώνυμο και το τηλέφωνο που δηλώσατε στο αίτημα.`,
      "Θα απαντήσουμε το αργότερο μέσα σε ένα (1) μήνα. Ενδέχεται να ζητήσουμε επιβεβαίωση ταυτότητας ώστε να μη δοθούν τα στοιχεία σας σε τρίτο.",
      "Αν θεωρείτε ότι παραβιάζονται τα δικαιώματά σας, μπορείτε να υποβάλετε καταγγελία στην Αρχή Προστασίας Δεδομένων Προσωπικού Χαρακτήρα (Κηφισίας 1-3, 115 23 Αθήνα, www.dpa.gr, complaints@dpa.gr, τηλ. +30 210 6475600).",
    ],
  },
  {
    title: "Εφαρμογή Android",
    list: [
      "Η εφαρμογή KORANI GROUP για Android εμφανίζει το περιεχόμενο της ιστοσελίδας koranigroup.com και συλλέγει μόνο όσα περιγράφονται σε αυτή την πολιτική.",
      "Η εφαρμογή δεν ζητά πρόσβαση σε επαφές, τοποθεσία, κάμερα, μικρόφωνο ή αρχεία της συσκευής. Το κουμπί κλήσης απλώς ανοίγει την εφαρμογή τηλεφώνου της συσκευής σας.",
      "Δεν απαιτείται δημιουργία λογαριασμού. Για διαγραφή των στοιχείων ενός αιτήματος ακολουθήστε τη διαδικασία της ενότητας 8.",
    ],
  },
  {
    title: "Ανήλικοι",
    body: ["Η ιστοσελίδα και η εφαρμογή απευθύνονται σε ενήλικες. Δεν συλλέγουμε εν γνώσει μας δεδομένα από άτομα κάτω των 15 ετών."],
  },
  {
    title: "Αλλαγές στην πολιτική",
    body: ["Μπορεί να ενημερώνουμε αυτή την πολιτική όταν αλλάζει ο τρόπος λειτουργίας της ιστοσελίδας ή της εφαρμογής. Η ημερομηνία τελευταίας ενημέρωσης αναγράφεται στην αρχή της σελίδας."],
  },
];
